var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSocialLike = function SvgSocialLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505C69",
    d: "M11.89 18.4c-1.86 0-7.223-4.62-7.223-8.932 0-2.053 1.86-3.901 3.94-3.901 1.642 0 2.736 1.026 3.393 1.848.547-.822 1.751-1.848 3.393-1.848 2.08 0 3.94 1.848 3.94 3.901-.219 4.312-5.582 8.83-7.442 8.932M8.608 6.593c-1.532 0-2.846 1.335-2.846 2.875 0 3.901 5.035 7.803 6.13 7.905 1.094 0 6.129-4.004 6.129-7.905 0-1.54-1.314-2.875-2.846-2.875-1.86 0-2.846 1.951-2.846 2.054-.218.41-.875.41-.985 0 .11-.103-.985-2.054-2.736-2.054"
  })));
};
export default SvgSocialLike;